export const DATE_RANGE_TYPES = {
  all_time        : "All Time",
  today           : "Today",
  yesterday       : "Yesterday",
  today_yesterday : "Today and yesterday",
  this_week       : "This week",
  last_week       : "Last week",
  this_month      : "This month",
  last_month      : "Last month",
  last_7          : "Last 7 days",
  last_14         : "Last 14 days",
  last_30         : "Last 30 days",
  last_60         : "Last 60 days",
  custom          : "Custom",
};

export const MONTHS_SHORT = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
